import "react-bootstrap-typeahead/css/Typeahead.css";
import { useEffect, useState } from "react";
import { UsersService } from "../../globals/services/users.service";
import { Input } from "reactstrap";
import styles from "./UserList.module.css";
import CircularProgress from "@mui/material/CircularProgress";

export const UserListInCurriculumEntity = ({ users, entity, entityType }) => {
  const [seminarUsers, setSeminarUsers] = useState([]);
  const [seminarBckUsers, setSeminarBckUsers] = useState([]);
  const [usersInitials, setUsersInitials] = useState({});
  const [regUserMsg, setRegUserMsg] = useState("");
  const [filteredUsersList, setFilteredUsersList] = useState([]);
  const [selectedUserToJoinEntity, setSelectedUserToJoinEntity] = useState("");
  const [unregisterLoading, setUnregisterLoading] = useState(null);
  const [registerLoading, setRegisterLoading] = useState(null);
  const [searchLoading, setSearchLoading] = useState(false);
  const [activeFilter, setActiveFilter] = useState("All");

  useEffect(() => {
    if (users && Array.isArray(users)) {
      const filtered = filterUser(users);
      setSeminarUsers(filtered);
      setSeminarBckUsers(filtered);
      setUsersInitials(groupedByFirstLetter(users));
    }
  }, [users]);

  const filterUser = (users) => {
    return users.sort((a, b) => {
      const entityRoleA = a.entityRole;
      const entityRoleB = b.entityRole;

      // First, check if either entityRole is "participant" and prioritize them to the bottom
      if (entityRoleA === "participant" && entityRoleB !== "participant") return 1;
      if (entityRoleA !== "participant" && entityRoleB === "participant") return -1;

      const firstNameA = (a.firstName || a.fullName || a.lastName || "").toLowerCase();
      const firstNameB = (b.firstName || b.fullName || b.lastName || "").toLowerCase();
      if (firstNameA < firstNameB) return -1;
      if (firstNameA > firstNameB) return 1;
      return 0;
    });
  };

  const handleUserSearch = async (value) => {
    setSearchLoading(true);
    setSelectedUserToJoinEntity(value);
    if (value && value.length > 2) {
      const filteredUsers = await UsersService().filterUserListByNameOrEmail(value);
      setFilteredUsersList(filteredUsers);
    } else {
      setRegUserMsg("");
      setFilteredUsersList([]);
    }
    setSearchLoading(false);
  };

  const unRegisterUser = async (userid, role) => {
    if (unregisterLoading === userid) return;

    setUnregisterLoading(userid);
    const response = await UsersService().unRegisterUserFromEntity(userid, entity, entityType, role);

    if (response) {
      setSeminarUsers(seminarUsers.filter((user) => user._id !== userid));
      setSeminarBckUsers(seminarBckUsers.filter((user) => user._id !== userid));
    }
    setUnregisterLoading(null);
  };

  const registerUserToEntity = async (e, userid, role) => {
    const userExists = seminarUsers.find((user) => user._id === userid && user.entityRole === role);

    if (!userExists) {
      setRegisterLoading(true);
      setFilteredUsersList([]);
      setSelectedUserToJoinEntity("");
      const response = await UsersService().registerUserToEntity(userid, entity, entityType, role);
      if (response) {
        const newUser = response.data.curricula.filter((curriculum) => curriculum.entityId === entity)[0];
        const parseUser = {
          entityRole: "participant",
          firstName: newUser.firstName,
          lastName: newUser.lastName,
          fullName: `${newUser.firstName} ${newUser.lastName}`,
          _id: newUser._id,
        };

        const filteredUser = filterUser([...seminarUsers, parseUser]);
        const filteredBckUsers = filterUser([...seminarBckUsers, parseUser]);
        setSeminarUsers(filteredUser);
        setSeminarBckUsers(filteredBckUsers);
        setRegisterLoading(false);
      }
    } else {
      setFilteredUsersList([]);
      setRegUserMsg("User is already registered to this entity");
    }
  };

  const renderCards = () => {
    return seminarUsers.map((c, index) => (
      <div className="d-flex flex-row bg-secondary userItemBox" key={c._id + c.entityRole + index}>
        <div className="p-2 bg-white userNameBox">{c.fullName || `${c.firstName} ${c.lastName}` || "no fullName"}</div>
        <div className="p-2 bg-white flex-grow-1">{c.entityRole || "no entity role"}</div>
        {c.entityRole === "participant" && (
          <div
            className={styles.unregisterButton}
            onClick={() => unRegisterUser(c._id, c.entityRole === "participant" ? "participant" : "teamMember")}
          >
            {unregisterLoading === c._id ? <CircularProgress size={18} color="inherit" style={{ color: "white" }} /> : "Unregister"}
          </div>
        )}
      </div>
    ));
  };

  const groupedByFirstLetter = (users) => {
    return users.reduce((acc, user) => {
      const firstLetter = (user.firstName || user.fullName || user.lastName || "").toUpperCase().charAt(0); // Get the first letter
      if (!acc[firstLetter]) {
        acc[firstLetter] = [];
      }
      acc[firstLetter].push(user); // Add user to the group
      return acc;
    }, {});
  };

  const handleFilterClick = (filter) => {
    setActiveFilter(filter);
    const updatedUsers = filter === "All" ? seminarBckUsers : usersInitials[filter];
    setSeminarUsers(updatedUsers);
  };

  return (
    <div>
      <Input
        id="selectedUserToJoinEntity"
        name="selectedUserToJoinEntity"
        placeholder="Add user to entity by name or email"
        type="text"
        onChange={(e) => handleUserSearch(e.target.value)}
        value={selectedUserToJoinEntity}
      />
      {regUserMsg.length > 0 ? <div className="text-danger">{regUserMsg} </div> : null}
      {registerLoading && (
        //TODO: its Patch please put real loader
        <div class="loading-text justify-content-start">
          Registering the user in the curricula, please wait<span>.</span>
          <span>.</span>
          <span>.</span>
        </div>
      )}
      <div className={"mb-3 mt-2"}>
        {filteredUsersList &&
          filteredUsersList.map((user, index) => {
            return (
              <div className={"d-flex flex-row add_to_entity"} key={user._id + index}>
                <div className={styles.resultRowLeft}>
                  {user.fullName} | {user.email}
                </div>
                <div className={"buttonClass2 mr-2"} onClick={(e) => registerUserToEntity(e, user._id, "participant")}>
                  Invite
                </div>
              </div>
            );
          })}
        {searchLoading && (
          //TODO: its Patch please put real loader
          <div className="loading-text text-align-center">
            Loading<span>.</span>
            <span>.</span>
            <span>.</span>
          </div>
        )}
      </div>
      <div className={`${styles.userFilterContainer} mb-2`}>
        {Object.entries(usersInitials).length !== 0 && (
          <>
            {["All", ...Object.keys(usersInitials)].map((filter) => (
              <div
                key={filter}
                className={`${activeFilter === filter ? styles.activeFilter : ""} ${styles.userFilter} mr-2`}
                onClick={() => handleFilterClick(filter)}
              >
                {filter}
              </div>
            ))}
          </>
        )}
      </div>
      <div className="mb-2 mt-3">Total: <span className={styles.totalUsers}>{seminarUsers.length} users</span></div>
      <div className="d-flex flex-row flex-wrap sessionsContainer">{renderCards()}</div>
    </div>
  );
};
